/**
 * RidesGate — capability gate for Carpool pages.
 *
 * Route-level ProtectedRoute only knows roles, but Carpool capabilities are "role OR right"
 * (a campus security user holds RidesSecurity; a staff member may hold Rides.Bookings.Manage
 * without a Carpool role). This gate asks useRidesPermissions instead.
 */

import type { ReactNode } from 'react';
import { IconLock } from '@tabler/icons-react';
import { LayoutContainer } from '@/components/ui/layout';
import { EmptyState } from '@/components/ui/data-display';
import { useRidesPermissions, type RidesPermissions } from '@/hooks/rides/useRidesPermissions';

interface RidesGateProps {
  allow: (p: RidesPermissions) => boolean;
  children: ReactNode;
}

export function RidesGate({ allow, children }: RidesGateProps) {
  const perms = useRidesPermissions();
  if (!allow(perms)) {
    return (
      <LayoutContainer>
        <EmptyState
          icon={<IconLock size={40} />}
          title="Access denied"
          description="You do not have permission to open this page. Ask a Carpool administrator for access."
        />
      </LayoutContainer>
    );
  }
  return <>{children}</>;
}
